import React from 'react'
import styles from './Footer.module.sass'

export function Footer() {
    return (
        <footer className={styles.footer}>
            <div>
                <span>© 2021,</span>
                <span className={styles.name}> Green House Staking</span>
            </div>
        </footer>
    )
}
